import { ContactProfilePhoto } from './contact-profile-photo';
import { ProfilePhoto } from './profile-photo';

export { usePhotoStore } from './use-photo-store';
export { useAvatarsWithPhotos } from './use-avatars-with-photos';
export const Photos = {
  ProfilePhoto,
  ContactProfilePhoto,
};
